import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Grid, Typography, Divider } from '@material-ui/core';
import { Pagination, Rating } from '@material-ui/lab';
import numeral from 'numeral';

// UTILITY
import { sendParentMessage } from '@/utility/common';
import { customAnalyticsEvent } from '@/utility/analytics';
import store from '@/utility/store';

// STORE
import { AppDetailsActions } from '@/store/actions';

// HOC
import withRouter from '@/hoc/withRouter';

// COMPONENTS
import Loader from '@/components/Loader';

// STYLES
import { RatingsContent, WriteReviewContent, RatingContent, ReviewsContent } from './styles';
import { Container } from '../../styles';

// HELP
// import FilterSelect from './help/FilterSelect';
import WriteReview from './help/WriteReview';

// const sortByOptions = [{ id: 1, name: 'None' }];
// const filterOptions = [{ id: 1, name: 'None' }];

class RatingsReviews extends PureComponent {
  state = {
    open: false,
    rating: 0,
  };

  handlePage = (e, page) => {
    const {
      router: {
        params: { slug },
      },
      pagination,
      getAppReviews,
    } = this.props;
    const paginationData = {
      page,
      per_page: pagination.per_page,
    };

    getAppReviews(slug, paginationData);
  };

  handleStartReview = (e, rating) => {
    const { isIframe, appId } = this.props;

    customAnalyticsEvent('Streaming Store Action', {
      category: 'Clicked Leave Review Button',
      app_id: appId,
    });

    this.setState({ open: true, rating });

    if (isIframe) {
      sendParentMessage({ goToTop: true });
    }
  };

  handleClose = () => {
    this.setState({ open: false, rating: 0 });
  };

  render() {
    const {
      t,
      pagination,
      appId,
      appRating,
      ratingCount,
      reviewsLoading,
      reviews,
      addAppReview,
      logo,
      appName,
      partner,
    } = this.props;
    const { open, rating } = this.state;

    const curAppRating = appRating ? (appRating / 20).toFixed(1) : '';
    const curRaring = ratingCount ? numeral(ratingCount).format('0.0a') : '';
    const page = pagination.current_page || 1;
    const last_page = pagination.last_page || 1;
    const app_ids = store.get('app_ids') || [];
    const reviewWasLeft = app_ids.includes(appId);

    return (
      <div id="ratings">
        <Container className="page-content">
          <div>
            <Grid container spacing={4}>
              <Grid item xs={12} md={5}>
                <RatingContent>
                  <Typography className="title" variant="h3">
                    {t('appDetails.ratingsReviews.title1')}
                    <br />
                    {t('appDetails.ratingsReviews.title2')}
                  </Typography>
                  <RatingsContent className="ratings-content">
                    {!!curAppRating && (
                      <div className="ratings-content__section">
                        <p className="ratings-content__mark">{+curAppRating}</p>
                        <Rating
                          className="ratings-content__rating"
                          value={+curAppRating}
                          precision={0.2}
                          readOnly
                        />
                        {!!curRaring && (
                          <p className="ratings-content__count p4">
                            {t('appDetails.ratingsReviews.countRatings', { count: curRaring })}
                          </p>
                        )}
                      </div>
                    )}
                    {/* <div className="ratings-content__section">
                      <ul className="ratings-content__picking">
                        <li className="picking-item">
                          <p className="p5 picking-item__mark">5</p>
                          <div className="picking-item__progress">
                            <LinearProgress variant="determinate" value={(980 / 10300) * 100} />
                          </div>
                          <p className="p5  picking-item__count">980</p>
                        </li>
                      </ul>
                    </div> */}
                  </RatingsContent>
                  {!reviewWasLeft && (
                    <WriteReviewContent className="write-review">
                      <Typography variant="h5">
                        {t('appDetails.ratingsReviews.writeReview')}
                      </Typography>
                      <Rating
                        name="def-rating"
                        className="sizeLarge write-review__rating"
                        value={rating}
                        onChange={this.handleStartReview}
                        precision={1}
                      />
                    </WriteReviewContent>
                  )}
                </RatingContent>
              </Grid>
              <Grid item xs={12} md={7}>
                <ReviewsContent className="reviews-content">
                  {reviews.length > 0 && (
                    <>
                      {/* <Grid container spacing={3} className="reviews-content__filters">
                    <Grid item xs={12} sm={7}>
                      <FilterSelect defaultValue={1} label="Sort by" options={sortByOptions} />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <FilterSelect defaultValue={1} label="Filter" options={filterOptions} />
                    </Grid>
                  </Grid> */}

                      {reviews.map((item, i) => {
                        return (
                          <div key={i} className="reviews-content__wrapper">
                            <div className="reviews-content__review">
                              <Rating
                                className="m-b-10"
                                value={item.rating}
                                precision={0.1}
                                readOnly
                              />
                              <div className="m-b-20 p4">
                                <span>{item.user_name}</span>
                                <span className="reviews-content__date">{item.date}</span>
                              </div>
                              {!!item.title && (
                                <Typography className="m-b-10" variant="h5">
                                  {item.title}
                                </Typography>
                              )}
                              {!!item.details && <p className="m-b-20 p4">{item.details}</p>}
                            </div>
                            <Divider />
                          </div>
                        );
                      })}
                      {last_page > 1 && (
                        <Pagination page={page} count={last_page} onChange={this.handlePage} />
                      )}
                    </>
                  )}
                  {reviews.length === 0 && !reviewsLoading ? (
                    <div className="reviews-content__empty">
                      <Typography variant="h5">
                        {t('appDetails.ratingsReviews.emptyState')}
                      </Typography>
                    </div>
                  ) : null}
                </ReviewsContent>
              </Grid>
            </Grid>
          </div>
          <Loader active={reviewsLoading} />
        </Container>
        <WriteReview
          appName={appName}
          logo={logo}
          open={open}
          rating={rating}
          onSubmit={data => addAppReview(appId, data)}
          onClose={this.handleClose}
          partner={partner}
        />
      </div>
    );
  }
}

RatingsReviews.defaultProps = {
  appRating: '',
  ratingCount: 0,
};

RatingsReviews.propTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  isIframe: PropTypes.bool.isRequired,
  appId: PropTypes.number.isRequired,
  appRating: PropTypes.string,
  ratingCount: PropTypes.number,
  reviews: PropTypes.array.isRequired,
  pagination: PropTypes.object.isRequired,
  reviewsLoading: PropTypes.bool.isRequired,
  getAppReviews: PropTypes.func.isRequired,
  addAppReview: PropTypes.func.isRequired,
  logo: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
  partner: PropTypes.object,
};

const mapStateToProps = ({ app, appDetails }) => ({
  isIframe: app.isIframe,
  reviews: appDetails.reviews.data,
  pagination: appDetails.reviews.meta,
  reviewsLoading: appDetails.loadings.reviews,
});

const mapDispatchToProps = dispatch => {
  return {
    getAppReviews: (slug, pagination) => {
      dispatch(AppDetailsActions.getAppReviews.action({ slug, pagination }));
    },
    addAppReview: (app_id, data) => {
      dispatch(AppDetailsActions.addAppReview.action({ app_id, data }));
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(),
  withRouter,
)(RatingsReviews);
